import styled from "styled-components";

export const Container = styled.section`
    padding-top: 15%;
    display: flex;
    justify-content: center;
    flex-direction: row-reverse;
    gap: 8rem;
    background: rgba(0, 0, 0, 0);

    .hero-text {
        p {
            font-size: 2.2rem;
        }

        h1 {
            font-size: 7rem;
        }

        h3 {
            font-size: 3rem;
            color: var(--blue);
            margin: 1rem 0;
        }

        p.small-resume {
            margin-bottom: 2rem;
        }
    }

    // New added

    .social-media {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding-top: 2rem;

        img,
        span {
            font-size: 3rem;
            width: 3.5rem;
        }
    }

    .button {
        margin-top: 2rem;
        padding: 1.4rem 6rem;
    }

    .hero-image {
        img {
            max-width: 500px;
        }
    }

    .hashnodeIcon, .stackOverflowIcon {
        width: 3rem !important;
    }

    @media (max-width: 960px) {
        display: block;
        margin-top: 15%;
        .hero-text {
            h1 {
                font-size: 5rem;
            }
        }

        .hero-image {
            display: none;
        }
    }

    @media (max-width: 600px) {
        margin-top: 35%;
    }
    @media (max-width: 480px) {
        margin-top: 45%;
    }

    .blinking-cursor {
        display: inline-block;
        width: 8px;
        animation: blink 1s infinite;
    }

    @keyframes blink {
        50% {
            opacity: 0;
        }
    }
`;
